import { render, staticRenderFns } from "./RuleItems.vue?vue&type=template&id=7c30a84a&"
import script from "./RuleItems.vue?vue&type=script&lang=ts&"
export * from "./RuleItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports